import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ReportDesignModel } from "../report-design.model";
import { AgencyModel, Appendix, selectAllAppendices, selectAllAppendixCategories } from "src/app/core/admin";
import { SupportingValuerModel } from "src/app/core/toe/_models/supporting-valuer.model";
import { DocumentTreeV2Component } from "../../reporting-process/reporting-settings/document-tree-v2/document-tree-v2.component";
import { OtherDocumentsComponent } from "../../reporting-process/reporting-settings/other-documents/other-documents.component";
import { ToeDocsComponent } from "../../reporting-process/reporting-settings/supporting-documents/toe-docs/toe-docs.component";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { IFile } from "../../reporting-process/reporting-settings/category.interface";
import { Store } from "@ngrx/store";
import { map } from "rxjs/operators";

@Component({
  selector: 'kt-supporting-documents-v2',
  templateUrl: './supporting-documents.component.html'
})
export class SupportingDocumentsV2Component implements OnInit {
  @Input()
  readonly: boolean;
  @Input()
  reporting: ReportDesignModel;
  @Input()
  agency: AgencyModel;
  @Input()
  leadValuer: SupportingValuerModel;
  @Input()
  members: SupportingValuerModel[];
  @Input()
  otherDocs: any[];

  private _appendices$ = new BehaviorSubject<number[]>([])
  @Input()
  set appendices(value: number[]) {
    this._appendices$.next(value)
  }

  @ViewChild('appendiceDocuments') appendicesFileTree: DocumentTreeV2Component;
  @ViewChild(OtherDocumentsComponent) documentUpload: OtherDocumentsComponent;
  @ViewChild(ToeDocsComponent) toeDocs: ToeDocsComponent;

  apData$: Observable<IFile[]>;
  constructor(
    private store$: Store
  ) { }

  ngOnInit(): void {
    this.apData$ = combineLatest([
      this.store$
        .select(selectAllAppendixCategories)
        .pipe(map((acs) => acs.filter((ac) => ac.appendix_cnt > 0))),
      this.store$.select(selectAllAppendices),
      this._appendices$.asObservable()
    ]).pipe(
      map(([appendixCategories, appendices, selectedAppendiceIds]) => {
        const files: IFile[] = [];
        appendixCategories.forEach((ac) => {
          const file: IFile = {
            id: ac.id,
            name: ac.name,
            isDir: true,
            selected: false,
            subFiles: this.appendixSubCategories(ac.id, appendices, selectedAppendiceIds),
          }
          files.push(file);
        })
        return files;
      })
    );
  }

  public getAppendicesFiles() {
    return this.appendicesFileTree.getDocuments();
  }
  public getUploadFiles() {
    return this.documentUpload.uploadFiles;
  }
  public getToeDocs() {
    return this.toeDocs.getToeDocs();
  }

  private appendixSubCategories(
    catID: number,
    appendices: Appendix[],
    selectedIds: number[]
  ): IFile[] {
    const files: IFile[] = [];
    appendices
      .filter(a => a.cat_id == catID)
      .forEach(a => {
        const file: IFile = {
          id: a.id,
          name: a.name,
          isDir: true,
          selected: false,
          subFiles: a.appendix_file.map((file) => ({
            id: file.id,
            name: file.title,
            selected: selectedIds.includes(file.id) ? true : false,
            isDir: false,
            url: file.path + '/' + file.name,
            subFiles: [],
          }))
        }
        files.push(file);
      })
    return files;
  }
}